export const interiorView04ImageOptions = {
  angle: 'InteriorView04',
  staticOptions: {
    StarboardAftCabinOptions: 1,
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    StarboardAftCabin: 1,
    FabricSaloon: 1,
    CupboardsOwnersCabin: 1,
    Mast: 1,
    TableBox: 1,
    Pouffes: 1,
    FabricCabins: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: 'PortAftCabinOptions'
    },
    {
      option: 'FabricCabins',
      dependency: 'PortAftCabinOptions'
    }
  ],
  overlays: []
}



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView04.js